import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import React from 'react';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import styles from '../index.module.scss';

interface PropsType {
  renderAdminList: () => JSX.Element;
  submitResult: string;
  submitDialogVisible: boolean;
  setSubmitDialogVisible: (value: boolean) => void;
}

export const SubmitResult = (props: PropsType) => {
  const {
    renderAdminList,
    submitResult,
    submitDialogVisible,
    setSubmitDialogVisible,
  } = props;


  return <>
    <Modal
      width={720}
      closeIcon={<IconClose/>}
      className={styles.modal}
      footer={null}
      title={submitResult === 'succ'
        ? <span><CheckCircleFilled style={{ color: '#3DD598', marginRight: '5px' }} />申请提交成功</span>
        : <span><ExclamationCircleFilled style={{ color: '#FC5A5A', marginRight: '5px' }} />申请提交失败</span>}
      visible={submitDialogVisible}
      onCancel={() => setSubmitDialogVisible(false)}
    >
      {submitResult === 'succ'
        ? <span className={styles.describe}>已向管理员发送企业微信的审核通知，可复制链接发送管理员审批，如遇紧急情况，联系审批人。
          </span>
        : <span className={styles.describe}>申请发送失败，可复制链接发送管理员手动添加。
          </span>}
      {renderAdminList()}
    </Modal>
  </>;
};
